import { ReactElement } from 'react';
import { Message, useMessage } from '@messageformat/react';
import parseMsgContent from '../../util/parseMsgContent';
import CourseContent from '../CourseContent';
import TextComponent from '../TextComponent';
import TaxationTile from './TaxationTile';
import AcquisitionTile from './AcquisitionTile';
import { ReactComponent as Image008 } from '../../images/OP_symbolikuvitus_128_008.svg';

const StockSection = (): ReactElement => {
  const introStock = useMessage('course9.stocks.intro');
  const parsedIntroStock = parseMsgContent(introStock);
  const firstTaxationArray = ['2 000 €', '1 700 €', '300 €', '-510 €'];
  const secondTaxationArray = ['5 000 €', '2 000 €', '-600 €'];
  const acquisitionArray = [
    '1 000 €',
    '10 €',
    '1 010 €',
    '4 000 €',
    '-897 €',
    '-720 €',
    '1 600 €',
  ];

  return (
    <>
      <Image008 className="investoracademy-small-svg" aria-hidden="true" />
      <CourseContent content={parsedIntroStock} headingAs="h2" />
      <h3 className="investoracademy-title-paragraph investoracademy-centered-and-padding-default-text">
        <Message id="course9.stocks.part1.title" />
      </h3>
      <TextComponent messageId="course9.stocks.part1.body" twoColumns />
      <TaxationTile
        baseKey="course9.stocks.dividend"
        costArray={firstTaxationArray}
        showAlternativeCalculation
      />
      <TaxationTile
        baseKey="course9.stocks.stock"
        costArray={secondTaxationArray}
        showAlternativeCalculation={false}
      />
      <h4 className="investoracademy-sub-title investoracademy-centered-and-padding-default-text">
        <Message id="course9.stocks.part2.title" />
      </h4>
      <TextComponent messageId="course9.stocks.part2.body" twoColumns />
      <h3 className="investoracademy-title-paragraph investoracademy-centered-and-padding-default-text">
        <Message id="course9.stocks.part3.title" />
      </h3>
      <TextComponent messageId="course9.stocks.part3.body" twoColumns />
      <h3 className="investoracademy-title-paragraph investoracademy-centered-and-padding-default-text">
        <Message id="course9.stocks.part4.title" />
      </h3>
      <TextComponent messageId="course9.stocks.part4.body" twoColumns />
      <AcquisitionTile costArray={acquisitionArray} />
    </>
  );
};

export default StockSection;
